import { IChannel, IChannelData } from "@/entities";

export class Channel implements IChannel {
  readonly id?: number;
  readonly text: string;

  constructor(data: IChannelData) {
    this.id = data.id;
    this.text = data.text;
  }
}
